interface UsedCard {
    stripe_customer_id: string;
    payment_method_id: string;
    last4: string;
    use_old_card: boolean;
}

export class ExtraUserContractPopupScreenData {
    title: string;
    view: string;
    number_of_extra_users: number;
    tax: number;
    tax_name: string;
    tax_imposed: number;
    payment_method: string;
    payment_file: File;
    used_card: UsedCard;
    file_input_key: number;
    file_input_error: boolean;
    message_listener: any;
    error_message: string;
    new_card_url: string;
    selected_contract_for_extra_user_contract_popup: any;

    constructor() {
        this.title = "Cargando...";
        this.view = 'loading';
        this.number_of_extra_users = 1;
        this.tax = 21;
        this.tax_name = "IVA";
        this.tax_imposed = 21;
        this.payment_method = 'transfer';
        this.payment_file = null;
        this.used_card = {
            stripe_customer_id: null,
            payment_method_id: null,
            last4: null,
            use_old_card: false,
        };
        this.file_input_key = 0;
        this.file_input_error = false;
        this.message_listener = null;
        this.error_message = null;
        this.new_card_url = null;
        this.selected_contract_for_extra_user_contract_popup = null;
    }
}